import ProcessingResult from "../../framework/ProcessingResult";

import DataSourceApi from "../../api/DataSourceApi";

import CreateOrUpdateDataSourceResult from "../../classes/api/result/datasourcemodule/CreateOrUpdateDataSourceResult";

export default class DataSourceCrudLogic {

    CreateOrUpdateDataSourceAsync = async (id: number | null, name: string, dataSourceType: number, customerAgentId: number | null, connectorType: number, parameters: object): Promise<ProcessingResult<CreateOrUpdateDataSourceResult>> => {

        if (id === null) {
            let createDataSourceResult = await DataSourceApi.CreateDataSourceAsync(name, dataSourceType, customerAgentId, connectorType, parameters);
            if (createDataSourceResult.IsFailed()) {
                return ProcessingResult.Error("Error in CreateDataSourceAsync " + createDataSourceResult.ErrorMessage);
            }

            return createDataSourceResult;
        }

        let updateDataSourceResult = await DataSourceApi.UpdateDataSourceAsync(id, name, dataSourceType, customerAgentId, connectorType, parameters);
        if (updateDataSourceResult.IsFailed()) {
            return ProcessingResult.Error("Error in UpdateDataSourceAsync " + updateDataSourceResult.ErrorMessage);
        }

        return updateDataSourceResult;
    }
}